import type { PaymentState } from '../api/client'
import { formatPrice, priceOrFree } from '../catalog/format'
import './VisitPrice.css'

// VisitPrice is a visit's price on her screens. A package session pays for it:
// the price struck through and £0, as the money came in when the package was
// sold. The stored total stays the treatment's price, so taking the package
// off a booked visit puts it back.
export default function VisitPrice({ pence, paymentState }: { pence: number; paymentState?: PaymentState }) {
  if (paymentState !== 'package' || pence <= 0) return <>{priceOrFree(pence)}</>
  return <span className="visit-price"><s aria-label={`was ${formatPrice(pence)}`}>{formatPrice(pence)}</s> {formatPrice(0)}</span>
}
